import React from 'react';
import { DollarSign } from 'lucide-react';

export function Billing() {
  return (
    <div className="p-8">
      <div className="flex items-center gap-3 mb-8">
        <DollarSign className="w-6 h-6 text-emerald-400" />
        <h2 className="text-2xl font-bold text-white">Billing</h2>
      </div>
      
      <div className="text-center py-12 bg-zinc-800/30 rounded-lg border border-zinc-700/30">
        <DollarSign className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
        <p className="text-zinc-400">Billing features coming soon...</p>
      </div>
    </div>
  );
}